<template>
  <div class="formulaListRight">
    <div class="header">
      <div @click="activeTab = item.id" v-for="item in tabList" :key="item.id" :class="item.id == activeTab ? 'header_tab active' : 'header_tab'">{{item.text}}</div>
    </div>
    <div class="list" v-if="activeTab=='1'">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list_item">
        <div class="list_item_header">
          <div class="list_item_left">
            <div class="list_item_left_drop"></div>
          </div>
          <div class="list_item_right">
            <div class="list_item_right_title">{{ item.actionName }}（{{ item.deptName }}）</div>
          </div>
        </div>
        <div v-if="item.createBy && item.createTime" class="list_item_content">
          <div class="list_item_left">
            <div class="list_item_left_line"></div>
          </div>
          <div class="list_item_right">
            <div v-if="item.operateData && item.operateData.resources && item.operateData.resources.length>0" class="list_item_right_text">
              <el-image 
                v-for="(item1, index) in item.operateData.resources"
                :key="index"
                style="width: 50px; height: 50px;margin: 6px"
                :src="item1.resUrl" 
                :preview-src-list="item.operateData.resources.map(item2 => item2.resUrl)"
              ></el-image>
            </div>
            <div class="list_item_right_text" v-if="item.action == '6' || item.action == '3'">配方区：{{ computedAreaText(item.areaId) }}</div>
            <div class="list_item_right_text">操作员：{{ item.createBy }}</div>
            <div class="list_item_right_text">操作时间：{{ item.createTime | dateFormat }}</div>
            <div class="list_item_right_text" v-if="item.remark">
              <span class="list_item_right_text_label">{{ item.action === 5 ? '拒绝原因' : '修改说明' }}：</span>
              <span class="list_item_right_text_value">{{ item.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list img-warp" v-if="activeTab=='2' && imgList && imgList.length>0">
      <div class="img-title">
        <div class="title-left">处方图片</div>
        <el-button @click="printImg">打印图片</el-button>
      </div>
      <div class="img-content">
        <img :src="imgList[index]" class="img">
        <div class="setup-warp">
            <div class="setup-action" @click="handleSwitch('left')"><</div>
            <div class="pl10 pr10">{{ index + 1 }}/{{ imgList.length }}</div>
            <div class="setup-action" @click="handleSwitch('right')">></div>
        </div>
      </div>
    </div>
     <!-- 打印 -->
     <printDialog
      ref="printDia"
      v-show="print.printDialogShow"
      :printDialogShow="print.printDialogShow"
      :id="print.printOrderId"
      :orderType="print.orderType"
      :printType="print.printType"
      @closePrintPrescription="closePrintPrescription"
      @printSuccess="printSuccess"
      @setPrintDiaShow="setPrintDiaShow">
    </printDialog>
  </div>
</template>

<script>
import { PrintDto } from '@/DTO/index'
import printDialog from '@/components/printDialog'
import { computed } from 'vue';
  export default {
    name: 'FormulaListRight',
    components:{printDialog},
    filters: {
      dateFormat(date) {
        return new Date(date).Format('yyyy-MM-dd hh:mm');
      }
    },
    props: {
      list: {
        type: Array,
        default: function() {
          return []
        }
      },
      imgList:{
        type:Array,
        default: function() {
          return []
        }
      },
      orderId:{
        type:String | Number,
        default: ''
      }
    },
    data() {
      return {
        tabList:[
          {text:'操作日志',id:'1'},
          {text:'图片处方',id:'2'},
        ],
        activeTab:'1',//激活tab
        index:0,
        print:{
          printDialogShow:false, // 打印弹框
          orderType: '4', // 打印处方订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
          printType: '10', // 打印类型 1小票 2处方
          printOrderId: '', // 打印单号
        },
      }
    },
    watch:{
      imgList:{
        deep:true,
        handler(){
          this.index=0
        }
      }
    },
    computed:{ 
      computedAreaText(){
        return function(val){
          const numText = {1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '七', 8: '八', 9: '九', 10: '十'}
          return val ?  `配方区${numText[val]}` : ''
        }
      }
    },
    methods:{
       //切换图片
       handleSwitch(type){
            let index = this.index
            if(index == -1) return;
            if(type =='left'){
                index = index == 0 ? 0 : index - 1
            }else if(type == 'right'){
                index = index == this.imgList.length - 1 ? this.imgList.length - 1 : index + 1;
            }
            this.index=index
        },
      // 打印弹窗展示
      setPrintDiaShow() {
        this.print.printDialogShow = true;
      },
      // 取消打印
      closePrintPrescription() {
        this.print.printDialogShow = false;
      },
      //打印成功
      printSuccess(){
      },
      //打印图片
      printImg(){
        this.print.printOrderId = this.orderId
        this.$nextTick(() => {
              this.$refs.printDia.useDefaultPrint()
            })
      },
    }
  }
</script>

<style lang="less" scoped>
  .formulaListRight{
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .header{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #E0E0E0;
  }
  
  .header_tab{
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    margin-right: 20px;
    cursor: pointer;
  }
  .active {
    color: #347EFF;
    position: relative;
    &::after {
        position: absolute;
        content: '';
        display: block;
        width: 70px;
        bottom: -20px;
        left: 50%;
        border-bottom: 2px solid #347EFF;
        transform: translateX(-50%);
    }
  }

  .list{
    box-sizing: border-box;
    padding: 12px 16px;
    width: 100%;
    height: calc( 100% - 56px );
    overflow-x: hidden;
    overflow-y: auto;
  }
  .img-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-left{
    color: #000;
    font-size: 14px;
  }
  .img-content{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    margin-top: 20px;
    .img{
      width: 210px;
      height: 280px;
    }
  }
  .setup-warp{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    margin-top: 12px;
    .setup-action{
        width: 24px;
        height: 24px;
        border: 1px solid #DCDFE6;
        line-height: 24px;
        text-align: center;
        cursor: pointer;
    }
  }
  .list_item{
    width: 100%;
  }

  .list>.list_item:not(:first-child){
    margin: 6px 0 0 0;
  }

  .list_item_header{
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  .list_item_content{
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .list_item_left{
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10px;
    height: 100%;
  }

  .list_item_left_drop{
    width: 8px;
    height: 8px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }

  .list_item_left_line{
    width: 1px;
    height: 100%;
    background-color: #1890FF;
  }

  .list_item_right{
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0 0 0 24px;
    width: calc( 100% - 24px);
  }

  .list_item_right_title{
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .list_item_right_text{
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .list_item_right_text_label{
    white-space: nowrap;
  }

  .list_item_right_text_value{
    word-wrap: break-word;
    word-break: break-all;
    text-align: left;
  }
</style>